import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ContactButton = () => {
  const { t } = useLanguage();

  return (
    <section className="contact-button-section py-2">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <Link 
              to="/request-demo" 
              className="btn btn-success btn-lg px-5 py-3 rounded-pill"
              style={{
                backgroundColor: '#07BC02',
                transition: 'transform 0.3s ease',
                display: 'inline-block'
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              {t('contactButton.text')} 
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactButton; 